<template>
    <v-tab v-bind="$attrs" exact-path class="min-w-auto" active-class="v-tab--active">
        <v-btn color="grey lighten-5" class="v-size--xx-large min-w-md-230px">
            <span class="font-weight-regular">
                <slot />
            </span>
        </v-btn>
    </v-tab>
</template>

<script>
export default {
    props: {},
    components: {},
    data: () => {
        return {};
    },
    computed: {},
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped>
.v-tab {
    &--active {
        .font-weight-regular {
            font-weight: 500 !important;
        }
    }
}
.v-application .v-tab {
    &--active {
        .v-btn {
            color: #fff !important;
            background-color: var(--v-primary-base) !important;
            border-color: var(--v-primary-base) !important;
        }
    }
}
.v-tabs--dark {
    .v-tab {
        .v-btn {
            color: var(--v-grey-lighten5) !important;
            background-color: transparent !important;
            border: 1px solid var(--v-grey-base) !important;
        }
        &--active {
            .v-btn {
                color: #fff !important;
                background-color: var(--v-primary-base) !important;
                border-color: var(--v-primary-base) !important;
            }
        }
    }
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .app--en {
        .v-tab {
            .min-w-md-230px {
                min-width: 220px !important;
            }
        }
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
